// extracted by mini-css-extract-plugin
export default {"wrap":"lF-z","fullWidth":"mF-z","hideOnDesktop":"nF-z","content":"oF-z","hasOpenedNav":"pF-z","crumbsList":"qF-z","dropdownsWrap":"rF-z"};